import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3307ac08"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ModulesCommonCallToAction: require('/opt/build/repo/components/Modules/Common/CallToAction/index.vue').default})
